exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mvT63bsJelcoFa{display:flex}.FhK9brIdF5rtqq{width:100%;margin-right:5%}._1EizxMTf-uoc5Q{margin:0 0 0 auto;width:38%}.PxLdYO36IGQq2G{display:flex;flex-direction:row;justify-content:space-between;align-content:center;margin:0;padding:0}.PxLdYO36IGQq2G ._3eS_I7r8e0_XKI{margin:0;background:none}.PxLdYO36IGQq2G ._3eS_I7r8e0_XKI:hover{background-color:none}._2KTrLb37BIv2PU{color:#5e6c84;font-size:12px;font-weight:600;line-height:16px;margin-top:20px;display:flex;align-items:center;margin-top:0;white-space:nowrap}._2KTrLb37BIv2PU ._1oTAgqqEYcHd7q{padding:0;font-weight:700}._2KTrLb37BIv2PU ._34xn1BrCMk8mZJ{margin-left:15px;margin-top:2px;font-size:14px}._2yj79KseX9rQ0Z{border:2px solid #5e6c84;border-radius:100px;padding:0;font-weight:700;width:16px;height:16px;font-size:12px;line-height:16px}", ""]);

// exports
exports.locals = {
	"container": "mvT63bsJelcoFa",
	"left": "FhK9brIdF5rtqq",
	"right": "_1EizxMTf-uoc5Q",
	"gettingStartedBar": "PxLdYO36IGQq2G",
	"ellipsis": "_3eS_I7r8e0_XKI",
	"header": "_2KTrLb37BIv2PU",
	"icon": "_1oTAgqqEYcHd7q",
	"headerTitle": "_34xn1BrCMk8mZJ",
	"check": "_2yj79KseX9rQ0Z"
};